<svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M-1.19209e-07 16V14H20V16H-1.19209e-07ZM2 12V4H4V12H2ZM6 12V0H8V12H6ZM10 12V0H12V12H10ZM17 12L13 5L14.75 4L18.75 11L17 12Z" fill="currentColor"/>
</svg>
